import store from '@/store';
import Favorites from './Favorites.vue';

const parent = { template: '<router-view></router-view>' };

function guardProducts(to, from, next) {
}

const routes = [
  {
    path: '/favorites',
    name: 'Favorites',
    component: Favorites,
    props: true,
  },
];

export default routes;
